// extracted by mini-css-extract-plugin
export default {"stats":"LongCruiseStats__stats___BBqJb","statsHr":"LongCruiseStats__statsHr___FCF5G"};